import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './Hero.module.scss';

Hero.propTypes = {
  title: PropTypes.string.isRequired,
  imageUrl: PropTypes.string,
};
Hero.defaultProps = {
  hero: undefined,
};

export default function Hero({ title, imageUrl }) {
  return (
    <div
      id="hero"
      className={classnames(styles.root, imageUrl && styles.withImage)}
      style={{ backgroundImage: imageUrl && `url(${imageUrl})` }}
    >
      <div className={styles.container}>
        <h1
          className={styles.title}
          dangerouslySetInnerHTML={{ __html: title.replace(/_(.+?)_/g, '<span>$1</span>') }}
        />
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Hero.js